'use strict';

/**
 * Layout view for filter modals
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/filter-modal.hbs');

var FilterModalView = LayoutView.extend({
    template: template,

    className: 'filter-modal-container',

    objectsCountTranslation: 'global::objects:count',

    regions: {
        activeFiltersRegion: '.filters-active',
        filtersRegion: '.filters',
    },

    ui: {
        actionClose: '[data-action="close"]',
        actionClearFilter: '[data-action="clear-filter"]',
        actionApplyFilters: '[data-action="apply-filters"]',
        actionGotoDefinition: '[data-action="goto-definition"]',
        resultCount: '.result-count',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
        'click @ui.actionClearFilter': 'actionClearFilter',
        'click @ui.actionApplyFilters': 'actionApplyFilters',
        'click @ui.actionGotoDefinition': 'actionGotoDefinition',
    },

    initialize: function(options) {
        this.$el.addClass('loading');
        this.components = _.result(this.collection, 'filterComponents');

        this.initializeComponents();
        this.listenTo(App.vent, 'filter:update', this.updateActiveFilters);

        LayoutView.prototype.initialize.apply(this, arguments);
    },

    initializeComponents: function() {
        this.components.forEach(function(section){
            section.forEach(function(component){
                var componentViewOptions = _.extend({}, {
                    name: component.name,
                    displayName: component.displayName,
                    title: component.title,
                    modelAttribute: component.modelAttribute,
                    activeFilters: this.getOption('activeFilter'),
                    collection: this.getOption('baseCollection'),
                    options: component.options,
                    type: component.type,
                }, component.options);

                component.view = new this.collection.componentViews[component.type](componentViewOptions);

                component.regionName = _.camelcase(component.name) + 'FilterComponentRegion';
            }.bind(this));
        }.bind(this));
    },

    onAttach: function() {
        this.ui.actionClose.focus();
        this.fixHeights();
    },

    onAfterOpen: function() {
        this.components.forEach(function(section){
            section.forEach(function(component){
                var region = this.addRegion(component.regionName, '.' + component.name + '-filter-component-region');
                region.show(component.view);
            }.bind(this));
        }.bind(this));

        this.updateActiveFilters();

        this.$el.removeClass('loading');
    },

    onFilterChange: function(newFilter) {
        console.log('Please provide a onFilterChange(newFilter) callback to FilterModalView');
    },

    onResize: function() {
        this.fixHeights();
    },

    viewData: {
        baseCollection: function() { return this.getOption('baseCollection'); },
    },

    renderComponentButton: function(component) {
        this.activeFiltersRegion.currentView.$el.append(component.view.renderFilterButton());
    },

    updateActiveFilters: function() {
        this.activeFiltersRegion.show(new EmptyView());

        this.components.forEach(function(section){
            section.forEach(function(component){
                this.renderComponentButton(component);
            }.bind(this));
        }.bind(this));

        var resultCount = this.getOption('baseCollection').getFilteredCount(this.getFilterString());
        this.ui.resultCount.html(App.t(this.objectsCountTranslation, resultCount));

        var filterCount = this.activeFiltersRegion.currentView.$('.active-filter').length;
        this.activeFiltersRegion.$el.toggle(filterCount > 0);

        this.fixHeights();
    },

    fixHeights: function() {
        var modalHeader = this.activeFiltersRegion.$el.closest('header');
        var modalBody = modalHeader.next('.modal-body');

        modalBody.outerHeight($(document.body).outerHeight() - modalHeader.outerHeight());
    },

    getFilterString: function() {
        var filters = [];
        this.components.forEach(function(section){
            section.forEach(function(component){
                var filterString = component.view.getFilterString();
                if (filterString) {
                    filters.push(filterString);
                }
            }.bind(this));
        }.bind(this));

        return filters.join('/');
    },

    actionClose: function(event) {
        this.trigger('close:modal');
    },

    actionClearFilter: function(event) {
        this.components.forEach(function(section){
            section.forEach(function(component){
                if (component.view.getOption('name') === $(event.currentTarget).data('filter-name')) {
                    component.view.resetFilters();
                }
            }.bind(this));
        }.bind(this));
    },

    actionApplyFilters: function() {
        if (
            (this.getOption('activeFilter') === null && this.getFilterString() === '') ||
            this.getOption('activeFilter') === this.getFilterString()
        ) {
            this.actionClose();
        } else {
            this.getOption('onFilterChange')(this.getFilterString());
        }
    },

    actionGotoDefinition: function(event) {
        var targetId = $(event.currentTarget).attr('href');
        var target = $(targetId);

        this.scrollFilterIntoView(target);

        event.preventDefault();
    },

    scrollFilterIntoView: function(target) {
        var scrollContainer = this.$('.modal-body');

        var scrollTop = target.position().top + scrollContainer.scrollTop() - this.$('.modal-header').outerHeight();

        scrollContainer.stop().animate({scrollTop: scrollTop});
    },
});

var EmptyView = LayoutView.extend({
    template: function(){ return ''; },
});

module.exports = FilterModalView;